export const getAllConditionsConfig = () => ({
  url: `/get_all_conditions`,
});

export const createConditionConfig = () => ({
  url: `/create_conditions`,
});

export const getConditionByIdConfig = (id) => ({
  url: `/conditions/${id}`,
});

export const editConditionConfig = (id) => ({
  url: `/conditions/${id}`,
});

export const deleteConditionConfig = (id) => ({
  url: `/delete_condition/${id}`,
});

export const filterConditionsConfig = () => ({
  url: `/specialtyConditions`,
});
